<template>
  <div>
    <div class="head">
      <el-switch
        v-model="value1" @change="switchStatus"
        active-text="开启编辑"
        inactive-text="关闭编辑">
      </el-switch>
    </div>
    <!-- 内容盒子 -->
    <div class="content">
      <el-tabs v-model="editableTabsValue" type="card" :editable="value1" @edit="handleTabsEdit" @tab-click="tabClick">
        <el-tab-pane
          :key="item.id"
          v-for="item in editableTabs"
          :label="item.name"
          :name="item.id | changeString"
        >
        </el-tab-pane>
      </el-tabs>
      <div>
        <el-button type="primary" size="small" :disabled="value1" @click="dialogVisibleDoc = true">新建</el-button>
        <el-button size="small" v-if="value1" @click="editTabName" :disabled="editableTabs.length === 0">编辑标签名</el-button>
        <el-button size="small" v-if="value1" @click="addTagDia">新建标签</el-button>
      </div>
      <!-- tab标签下面的表格 -->
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column prop="num" label="编号"></el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope">
            <el-link type="primary" @click="downLoad(scope.row)">{{ scope.row.name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="文件版本" prop="versionNumber"></el-table-column>
        <el-table-column label="发布日期" prop="upTime">
          <template slot-scope="{ row }">
            <span v-if="row.upTime">{{ row.upTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实施日期" prop="materialDate">
          <template slot-scope="{ row }">
            <span v-if="row.materialDate">{{ row.materialDate | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发放范围" prop="distributionScope"></el-table-column>
        <el-table-column label="手册级别" prop="level"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.status">{{ statusList[row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="cursor: pointer;color: #1890FF" @click="operation(scope.row)">编辑</span>
            <span style="margin: 0 10px;color: #e8e8e8">|</span>
            <span style="cursor: pointer;color: #FF0000" @click="removeTableData(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="textAlign: right;marginTop: 15px">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="limit"
          :current-page="curPage"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 编辑标签页的弹窗 -->
    <el-dialog
      title="编辑标签名"
      :visible.sync="dialogVisible"
      width="30%">
      <div v-for="(item,index) in arr" :key="index" class="inpBox">
        <div><el-input size="small" type="primary" class="input1" v-model="item.name" /></div>
        <div><el-button size="small" class="inputSave" @click="editType(item)">保存</el-button></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增表格数据的弹窗 -->
    <div>
      <el-dialog
        title="新增文件" @close="closeAddTable"
        :visible.sync="dialogVisibleDoc"
        top="2vh" width="40%">
        <el-form label-width="80px" :model="form" ref="form" size="small" style="padding: 0 40px 0 0">
          <el-form-item label="文件编号">
            <el-input v-model="form.num"></el-input>
          </el-form-item>
          <el-form-item label="选择文件">
            <el-upload
              class="upload-demo"
              drag
              action="/v1/datamanage/uploadFile" :on-success="uploadSuccess"
              :on-remove="uploadRemove"
              :limit="1" :on-exceed="handleExceed" :file-list="fileList">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件名称">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="文件版本">
            <el-input v-model="form.versionNumber" />
          </el-form-item>
          <el-form-item label-width="0" style="margin-bottom: 0">
            <el-col :span="12">
              <el-form-item label="发布日期">
                <el-date-picker v-model="form.upTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实施日期">
                <el-date-picker v-model="form.materialDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="发放范围">
            <el-input v-model="form.distributionScope" />
          </el-form-item>
          <el-form-item label="手册级别">
            <el-input v-model="form.level" />
          </el-form-item>
          <el-form-item label-width="0" style="margin-bottom: 0">
            <el-col :span="12">
              <el-form-item label="创建人">
                <el-select v-model="form.createUserId" @change="selectChange($event, 1)">
                  <el-option v-for="user1 in userList" :key="user1.id" :value="user1.id" :label="user1.nickname" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审批人">
                <el-select v-model="form.auditUserId" @change="selectChange($event, 2)">
                  <el-option v-for="user2 in userList" :key="user2.id" :value="user2.id" :label="user2.nickname" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="流程模板">
            <el-select v-model="form.definitionId" placeholder="请添加" @change="selectChange($event, 3)">
              <el-option v-for="m in modules" :key="m.id" :label="m.name" :value="m.definitionId" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addTableData" size="small" type="primary">确 定</el-button>
          <el-button @click="dialogVisibleDoc = false" size="small">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { resourceTypeSave, resourceGetType, resourceTypeRemove, resourceTypeEdit,
         resourceTableList, resourceAddTable, resourceDeleteTable, resourceEditTable,
         getAlluser } from "@/api/processManager"
import { downLoadDocument } from '@/api/downLoad'
import { modulesList } from "@/api/model"
export default {
  name: 'processResource',
  data(){
    return {
      // 开关的状态值
      value1: false,
      editableTabsValue: '0',
      // 标签页的头部
      editableTabs: [],
      // 这里是用新数组arr接收一下头部的数据，防止用一个数据，弹框修改名字的时候
      // 如果没点保存，关闭弹框后，前端修改成功，但其实后端没接受值
      arr: [],
      tabIndex: 2,
      // 表格的数据
      tableData: [],
      dialogVisible: false, // 编辑标签名弹窗的状态
      limit: 10,
      curPage: 1,
      total: 0,
      // 上传文件的一些东西
      dialogVisibleDoc: false,
      form: {
        name: '',
        url: '',
        num: ''
      },
      inpStatus: true,
      fileList: [],
      userList: [], //用户列表
      modules: [], // 流程模板列表
      statusList: ['待提交', '待审核', '驳回', '通过', '']
    }
  },
  filters: {
    changeString(val) {
      return val.toString()
    }
  },
  methods: {
    // 获取所有用户
    getAlluser() {
      getAlluser().then(res => {
        this.userList = res.body.data
      })
    },
    // 获取模板列表
    getModulesList() {
      modulesList().then(res => {
        this.modules = res.body.data
      }) 
    },
    // 下拉选择框改变
    selectChange(e, status) {
      let obj = {}
      if(status === 1) {
        obj = this.userList.find(v => {
          return v.id === e
        })
        this.form.createUserName = obj.nickname
      }else if(status === 2) {
        obj = this.userList.find(v => {
          return v.id === e
        })
        this.form.auditUserName = obj.nickname
      }else if(status === 3) {
        obj = this.modules.find(v => {
          return v.definitionId === e
        })
        this.form.key = obj.key
      }
    },
    // 开关
    switchStatus(val) {
      console.log(val)
    },
    // 添加标签弹窗的方法
    addTagDia() {
      // 添加标签的弹窗
      this.$prompt('请输入标签名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if(value === ''){
          this.$message.error('标签名不能为空')
          return
        }else{
          resourceTypeSave({name: value}).then(res => {
            this.getType()
            this.$message.success('添加成功')
          })
        }
      }).catch(() => {
        return     
      });
    },
    // 添加标签
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        this.addTagDia()
      }
      // 删除标签
      if (action === 'remove') {
        let arr = this.editableTabs
        let name1 = ''
        for(let i in arr) {
          if(arr[i].id == targetName){
            name1 = arr[i].name
          }
        }
        this.$confirm(`删除 "${name1}" , 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resourceTypeRemove(targetName).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getType()
          })
        }).catch(() => {
          return
        });
      }
    },
    // 修改标签名的弹窗
    editTabName(){
      this.dialogVisible = true
      this.arr = JSON.parse(JSON.stringify(this.editableTabs))
      // this.arr = this.editableTabs
    },
    // 保存标签名
    editType(val) {
      // console.log(val)
      if(val.name === ''){
        this.$message.info('标签的名字不能为空')
        return
      }
      resourceTypeEdit({id: val.id, name: val.name}).then(res => {
        this.getType()
        this.dialogVisible = false
        this.$message.success('修改成功')
      })
    },
    // 标签页头部被点击的事件
    tabClick(val) {
      // console.log(val)
      this.getTableList(this.editableTabsValue)
    },
    // 获取所有标签
    getType() {
      // resourceGetType({}).then(res => {
      //   this.editableTabs = res.body.data
      //   if(this.editableTabs.length === 0) {
      //     this.value1 = true
      //   }else{
      //     this.editableTabsValue = res.body.data[0].id.toString()
      //   }
      // })
      resourceGetType({}).then(res => {
        this.editableTabs = res.body.data
        if(this.editableTabs.length === 0) {
          this.value1 = true
        }else{
          this.editableTabsValue = res.body.data[0].id.toString()
          this.getTableList(this.editableTabsValue)
        }
      })
    },
    // 获取某个标签下面的表格
    getTableList(val) {
      resourceTableList({ typeId: val, limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    // 限制文件上传个数
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，如要更改，请删除后重新上传`);
    },
    // 上传文件成功的回调
    uploadSuccess(file,fileList) {
      this.form.url = file.data
      // this.form.name = fileList[0].name
      this.$set(this.form, 'name', fileList[0].name)
    },
    // 删除文件
    uploadRemove(file, fileList) {
      this.fileList = []
      this.form.url = '',
      this.form.name = ''
    },
    // 关闭添加表格数据的弹窗
    closeAddTable() {
      this.fileList = []
      this.inpStatus = true
      this.form = {}
    },
    // 添加数据
    addTableData() {
      if(this.inpStatus === true){
        resourceAddTable({...this.form, typeId: this.editableTabsValue}).then(res => {
          this.getTableList(this.editableTabsValue)
          this.dialogVisibleDoc = false
        })
      }else{
        resourceEditTable({ ...this.form, id: this.form.id }).then(res => {
          this.getTableList(this.editableTabsValue)
          this.dialogVisibleDoc = false
        })
      }
    },
    // 删除数据
    removeTableData(row) {
      this.$confirm(`删除${row.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resourceDeleteTable(row.id).then(res => {
          if(this.tableData.length <= 1 && this.curPage > 1) {
            this.curPage -= 1
          }
          this.getTableList(this.editableTabsValue)
          this.$message.success('删除成功')
      })
      }).catch(() => {
        return       
      });
    },
    // 操作
    operation(val) {
      this.$set(this.form, 'name', val.name)
      this.$set(this.form, 'num', val.num)
      this.$set(this.form, 'url', val.url)
      this.$set(this.form, 'id', val.id)
      this.$set(this.form, 'versionNumber', val.versionNumber)
      this.$set(this.form, 'upTime', val.upTime)
      this.$set(this.form, 'materialDate', val.materialDate)
      this.$set(this.form, 'distributionScope', val.distributionScope)
      this.$set(this.form, 'level', val.level)
      this.inpStatus = false
      this.dialogVisibleDoc = true
      this.fileList.push({name: val.name})
    },
    // 下载文件
    downLoad(val) {
      downLoadDocument(val.url, val.name)
    }
  },
  created() {
    // resourceGetType({}).then(res => {
    //   this.editableTabs = res.body.data
    //   if(this.editableTabs.length === 0) {
    //     this.value1 = true
    //   }else{
    //     this.editableTabsValue = res.body.data[0].id.toString()
    //     this.getTableList(this.editableTabsValue)
    //   }
    // })
    this.getType()
    this.getAlluser()
    this.getModulesList()
  }
}
</script>

<style scoped>
  .head {
    display: flex;
    justify-content: space-between
  }
  .inpBox {
    display: flex;
    margin-bottom: 10px
  }
  .input1 {
    width: 280px
  }
  .inputSave {
    margin-left: 10px;
  }
</style>